import React, { useState } from "react";
import { IoMdCheckmarkCircle, IoMdInformationCircle } from "react-icons/io";
import { PiEnvelopeSimple, PiPhone } from "react-icons/pi";
import { useContextState } from "../../../context/ContextProvider";

import { ERROR_MSG, ROLE } from "../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../constants/contexConstant";
import { EMAIL_VERIFICATION_CODE_ENDPOINT } from "../../../constants/routes";
import { checkIsAllowed } from "../../../helpers/helpers";
import cn from "../../../lib/cn";
import request from "../../../services/request";
import P from "../../../shared/typography/P";

const ProfileCard = ({ address }) => {
    const { state, dispatch } = useContextState();
    const user = state?.user || {};
    const [isMailSent, setMailSent] = useState(false);

    const isEmailConfirmed = user?.isEmailConfirmed;
    const userType = checkIsAllowed(user?.roles, [ROLE.CONSUMER_OWNER])
        ? "Owner"
        : "User";

    const handleSentVerificationEmail = async () => {
        try {
            dispatch({ type: SET_LOADER });
            await request.authGet({
                endpoint: EMAIL_VERIFICATION_CODE_ENDPOINT,
            });

            dispatch({ type: RESET_LOADER });
            setMailSent(true);
            setTimeout(() => {
                setMailSent(false);
            }, 20000);
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };
    return (
        <div className="bg-blue-550 lg:bg-white   shadow-md lg:shadow-none lg:border lg:border-blue-60 rounded-2 lg:rounded-sm lg:mb-2.4 p-1.6 ">
            <div className="flex  flex-wrap  justify-between  items-center w-full  ">
                <div className=" flex xl:items-center flex-wrap xl:flex-nowrap  gap-1 w-full xl:w-[55%] ">
                    <div className=" flex items-center justify-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] xl:w-[4rem] xl:h-[4rem] 2xl:w-[50px] 2xl:h-[50px] rounded-full bg-gray-300 ">
                        <h3 className="text-white font-semibold text-base sm:text-5xl lg:text-3xl font-vietnam ">
                            {user?.name.charAt(0)}
                        </h3>
                    </div>
                    <div className="flex-1">
                        <div className="flex justify-between gap-0.5 items-center w-full">
                            <P className="text-xs text-white lg:text-primary overflow-hidden font-vietnam line-clamp-1  text-ellipsis">
                                {user?.name}
                            </P>
                            <div className="flex items-center gap-0.4">
                                <P
                                    className={cn(
                                        "text-nowrap text-xs  flex items-center gap-0.4 border rounded-full  px-1.5 py-0  xl:text-sm 2xl:text-sm  font-vietnam border-solid  text-white  lg:text-gray-140 border-white lg:border-gray-120"
                                    )}
                                >
                                    {userType}
                                </P>
                            </div>
                        </div>

                        <div className="sm:gap-2 xl:block xl:mt-1 2xl:mt-0.5   ">
                            <div className="flex items-center gap-0.5">
                                <PiPhone className="text-xxl text-white  lg:text-primary" />{" "}
                                <P className="text-white  lg:text-primary text-2xs md:text-sm xl:text-sm 2xl:text-sm font-vietnam">
                                    {user?.phoneNumber &&
                                        `+${user?.phoneNumber}`}
                                </P>
                            </div>
                            <div className="flex justify-between items-center">
                                <div className="  flex items-center gap-0.5 mt-0.5 sm:mt-0 xl:mt-0.6">
                                    <PiEnvelopeSimple className="text-xxl text-white  lg:text-primary" />
                                    <P className="text-white  lg:text-primary text-2xs md:text-sm xl:text-sm 2xl:text-sm font-vietnam line-clamp-1  text-ellipsis">
                                        {user?.email}
                                    </P>
                                </div>

                                <P
                                    className={cn(
                                        "text-nowrap  flex items-center gap-0.4 border rounded-full  px-1 py-0.4   text-2xs  xl:text-sm 2xl:text-sm  font-vietnam border-solid",
                                        {
                                            "text-orange border-orange":
                                                !isEmailConfirmed,
                                            "text-green-200 border-green-200":
                                                isEmailConfirmed,
                                        }
                                    )}
                                >
                                    {isEmailConfirmed ? (
                                        <>
                                            Verified <IoMdCheckmarkCircle />
                                        </>
                                    ) : (
                                        <>
                                            Not Verified
                                            <IoMdInformationCircle />
                                        </>
                                    )}
                                </P>
                            </div>
                            {!isEmailConfirmed && (
                                <div className="flex justify-end">
                                    {isMailSent ? (
                                        <P className="text-sm text-green-500 flex items-center gap-0.5">
                                            Email has been sent{" "}
                                            <IoMdCheckmarkCircle />
                                        </P>
                                    ) : (
                                        <button
                                            onClick={
                                                handleSentVerificationEmail
                                            }
                                            className="text-white lg:text-primary font-vietnam mt-0.5 text-2xs underline "
                                        >
                                            Resend Verification Email
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="xl:inline-block w-full h-px xl:h-[50px]  xl:w-px bg-blue-300 my-1.2  xl:my-1.6"></div>
                <div className="flex flex-col xl:w-[40%]  xl:justify-end xl:items-end">
                    <div>
                        <P className=" xl:text-right text-xs md:text-sm xl:text-sm 2xl:text-sm text-white lg:text-primary font-vietnam">
                            {/* {user?.address} */}
                            Address
                        </P>
                    </div>

                    <P className="mt-0.2 xl:text-right text-xs md:text-sm xl:text-sm 2xl:text-sm text-white lg:text-primary font-vietnam">
                        {address?.address}
                    </P>
                </div>
            </div>
        </div>
    );
};

export default ProfileCard;
